import { customer } from "@api/filters/customer/api";
import { employeeCost } from "@api/filters/employeeCost/api";
import { measurementUnit } from "@api/filters/measurementUnit/api";
import { paidInstallment } from "@api/filters/paidInstallment/api";
import { productCategory } from "@api/filters/productCategory/api";
import { productPlan } from "@api/filters/productPlan/api";
import { purchaseInvoices } from "@api/filters/purchaseInvoices/api";
import { salesInvoices } from "@api/filters/salesInvoices/api";
import { store } from "@api/filters/store/api";
import { storeCost } from "@api/filters/storeCost/api";
import { subscription } from "@api/filters/subscription/api";
import { supplier } from "@api/filters/supplier/api";
import { unpaidInstallment } from "@api/filters/unpaidInstallment/api";
import { user } from "@api/filters/user/api";
import { warehouse } from "@api/filters/warehouse/api";

export const filters = {
  productPlan,
  paidInstallment,
  store,
  subscription,
  unpaidInstallment,
  warehouse,
  productCategory,
  measurementUnit,
  user,
  customer,
  supplier,
  storeCost,
  employeeCost,
  purchaseInvoices,
  salesInvoices,
};
